<template>
	<v-card>
		<v-card-title class="pb-0">
			<v-avatar size="38" class="mr-3">
				<v-icon color="white" small> fas fa-receipt</v-icon>
			</v-avatar>
			<h3>Receitas</h3>
		</v-card-title>
		<v-card-text>
			<v-container fluid grid-list-md>
				<v-layout wrap>
					<v-flex v-for="(receita, i) in receitas" :key="receita.id" shrink>
						<div class="img-container q-row justify-center">
							<v-btn
								v-if="!readOnly"
								small
								icon
								@click="abrirDialog(receita, 'dialog_remover_receita')"
								class="purple delete-btn">
								<v-icon small color="white">delete</v-icon>
							</v-btn>
							<v-icon v-if="receita.url.includes('.pdf')" @click="openPdf(receita)" :disabled="abrindoPdf" size="50" class="pointer pa-4"
								color="purple">fas fa-file-pdf</v-icon>
							<img
								v-else
								class="pointer"
								:class="{ selecionada: i === index }"
								:src="receita.url"
								@click="handleClick(i)"
								alt="Receita" width="60" height="60"/>
						</div>
						<v-tooltip top>
							<span slot="activator">{{ receita.name.substring(0, 15) }}</span>
							<span>
								{{ receita.name }}
							</span>
						</v-tooltip>
					</v-flex>
					<v-flex
						v-if="!readOnly"
						xs12
						md12
						align-center justify-start>
						<v-btn depressed class="ml-0 purple white--text" @click="onClick" :loading="enviarReceita">
							<v-icon small class="mr-2">cloud_upload</v-icon>
							Escolher receita
						</v-btn>
						<span v-if="erro_upload" class="error--text">
							Você enviou uma imagem com o formato não permitido. Envie apenas
							imagens no formato jpeg, png ou pdf.
						</span>
						<input
							type="file"
							ref="upload"
							@change="previewImage"
							accept="image/png, image/jpeg, application/pdf"
							multiple/>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card-text>
		<v-dialog
			persistent
			scrollable
			v-model="dialog_remover_receita"
			transition="fade"
			max-width="340px">
			<transition>
				<Dialog
					v-if="dialog_remover_receita"
					titulo="Remover receita"
					subtitulo="Esta ação não pode ser desfeita"
					btn_acao="Remover"
					btn_acao_class="error"
					btn_cancelar="Cancelar"
					:loading="deleting"
					@acao="removerReceita"
					@close="dialog_remover_receita = false"/>
			</transition>
		</v-dialog>

		<v-dialog v-model="dialog_visualizar_receitas" scrollable transition="fade" fullscreen>
			<transition>
				<DialogVisualizarReceitas v-if="dialog_visualizar_receitas" :receitas="receitas"
					:index="index" @close="dialog_visualizar_receitas = false"/>
			</transition>
		</v-dialog>
	</v-card>
</template>

<script>
import { compress } from 'lz-string';
import { ReceitaPresenter } from '@Presenter/receita-presenter';
import DialogVisualizarReceitas from '@Componentes/assinatura/dialog-visualizar-receitas.vue';
import axios from 'axios';
import { openBuffer } from '@Util/functions';

export default {
	name: 'Receitas',
	components: { DialogVisualizarReceitas },
	data: () => ({
		dialog_visualizar_receitas: false,
		dialog_remover_receita: false,
		deleting: false,
		erro_upload: false,
		item_selecionado: null,
		enviarReceita: false,
		abrindoPdf: false
	}),
	props: {
		index: {
			type: Number,
			required: true
		},
		receitas: {
			type: Array,
			required: true
		},
		readOnly: {
			type: Boolean,
			required: false
		},
		box_id: {
			type: Number,
			required: false
		},
		assinatura_id: {
			type: Number,
			required: false
		}
	},
	methods: {
		handleClick(index) {
			this.$emit('receita-selecionada', index);
			if (!this.noZoom)
				this.abrirDialog(index, 'dialog_visualizar_receitas');
		},
		abrirDialog(item, nome) {
			this.item_selecionado = item;
			this[nome] = true;
		},
		removerReceita() {
			this.deleting = true;
			ReceitaPresenter.destroy(this.item_selecionado.id)
				.then(() => {
					const i = this.receitas.findIndex(
						receita => receita.id === this.item_selecionado.id
					);
					if (i !== -1)
						this.receitas.splice(i, 1);
					this.dialog_remover_receita = false;
					this.$root.$emit('alterou_receita', true);
				})
				.finally(() => {
					this.deleting = false;
				});
		},
		onClick() {
			this.$refs.upload.click();
			this.erro_upload = false;
		},
		abrirReceita(receita) {
			if (this.rt)
				this.$emit('receita-selecionada', receita);
			else
				window.open(receita.url);
		},
		previewImage(e) {
			this.erro_upload = false;
			if (e.target) {
				Object.keys(e.target.files).forEach(id => {
					const file = e.target.files[id];
					if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'application/pdf') {
						this.erro_upload = true;
						return;
					}
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');
					const maxW = 1000;
					const maxH = 1500;

					if (file.type === 'application/pdf') {
						this.enviarReceita = true;
						const reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onloadend = () => {
							const base64data = reader.result;
							const compressData = compress(base64data);
							ReceitaPresenter.store({
								assinatura_id: this.assinatura_id,
								box_id: this.box_id,
								receita_base64: compressData,
								tipo: file.type,
								name: file.name
							}).then(receita => {
								this.receitas.push(receita);
								this.$root.$emit('alterou_receita', true);
							}).finally(() => {
								this.enviarReceita = false;
							});
						};
					} else {
						const img = new Image();
						img.onload = () => {
							const iw = img.width;
							const ih = img.height;
							const scale = Math.min(maxW / iw, maxH / ih);
							const iwScaled = iw * scale;
							const ihScaled = ih * scale;
							canvas.width = iwScaled;
							canvas.height = ihScaled;
							ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
							this.enviarReceita = true;
							const compressDataUrl = compress(canvas.toDataURL('image/jpeg', 0.7));
							ReceitaPresenter.store({
								assinatura_id: this.assinatura_id,
								box_id: this.box_id,
								receita_base64: compressDataUrl,
								name: file.name
							}).then(receita => {
								this.receitas.push(receita);
								if (this.rt)
									this.abrirReceita(receita);
								this.$root.$emit('alterou_receita', true);
							}).finally(() => {
								this.enviarReceita = false;
							});
						};
						img.src = URL.createObjectURL(file);
					}
				});
				e.target.value = '';
			}
		},
		openPdf(receita) {
			this.abrindoPdf = true;
			axios.get(receita.url, { responseType: 'arraybuffer' })
				.then(response => openBuffer(response.data))
				.catch(() => {
					this.$store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Erro ao abrir PDF' });
				})
				.finally(() => {
					this.abrindoPdf = false;
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@Assets/css/settings.scss";

input {
  display: none;
}

.q-column {
  min-height: 100px;
}

.btn {
  background: lightgrey;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.img-container {
  position: relative;

  .delete-btn {
	opacity: 0;
	transition: opacity 0.3s;
  }

  &:hover {
	.delete-btn {
		opacity: 1;
	}
  }

  button {
	position: absolute;
	right: 0;
  }

  img {
	max-height: 100px;

	&.selecionada {
		box-shadow: 0 0 20px $purple;
	}
  }
}

.container {
  padding: 0;
}
</style>
